export default __webpack_public_path__ + "static/media/TourGuidePage_05.233fa125.jpg";